<template>
    <div class="">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaSaldos }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <!-- <input type="month" v-model="fechaSaldos" class="form-control"> -->
                <select v-model="fechaSaldos" class="form-control">
                    <option value="">{{ labels.seleccion }}</option>
                    <option v-for="item in lstFechaSaldos" :key="item.id" :value="item.vigencia"> {{ item.vigencia }} </option>
                </select>
            </div>
        </div>
        <b-row class="mt-5">
            <b-col class="d-flex justify-content-center">
                <md-button @click="consultSaldosPorContrato" id="create-btn">{{ labels.consPorContrato }}</md-button>
            </b-col>
            <!-- <b-col class="d-flex justify-content-center">
                <md-button @click="consultSaldosPorCuenta" class="md-dense md-raised md-primary btn-info">{{ labels.consPorCuenta }}</md-button>
            </b-col> -->
        </b-row>
        <div class="col-md-12 mt-4" v-if="showPorContrato">
            <b-row class="d-flex justify-content-center col-12">
                <h1 class="md-title"><b>{{ labels.subTitle }}</b></h1>
            </b-row>
            <b-row v-if="loading" class="justify-content-center mt-5">
                <b-spinner
                    label="Cargando..."
                    variant="primary"
                    style="width: 3rem; height: 3rem;"
                ></b-spinner>
            </b-row>
            <div class="row col-md-12 justify-content-center" v-if="lstSaldos.length > 0">
                <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                    <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genExcelSaldContabPorCont()">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                        </md-icon>
                    </md-button>
                </div>
                <b-table
                    :items="lstSaldos"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter="filtroContrato"
                    :filter-function="filtrarPorContrato"
                    @row-clicked="(item) => consSaldPorContrCuenta(item.nro_contrato,item.vigencia)"
                >
                    <template #cell(nro_contrato)="data">
                        <div class="text-right">{{ data.item.nro_contrato }}</div>
                    </template>
                    <template #cell(identificacion)="data">
                        <div class="text-left">{{ proveedor(data.item.identificacion) }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="lstSaldos.length"
                        :per-page="perPage"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <div v-else>
                <h5>{{ labels.noRow }}</h5>
            </div>
        </div>
        <div class="col-md-12 mt-4" v-if="showPorCuenta">
            <b-row class="d-flex justify-content-center col-12">
                <h1 class="md-title"><b>{{ labels.subTitleCuenta }}</b></h1>
            </b-row>
            <div class="row col-md-12 justify-content-center" v-if="lstSaldPorCuenta.length > 0">
                <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                    <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genExcelSaldContabPorCuent()">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                        </md-icon>
                    </md-button>
                </div>
                <b-table
                    :items="lstSaldPorCuenta"
                    :fields="field"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="(item) => consSaldCuenta(item.cuenta)"
                >
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="lstSaldPorCuenta.length"
                        :per-page="perPage"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <div v-else>
                <h5>{{ labels.noRow }}</h5>
            </div>
        </div>
        <ModConsxContratxCuenta :modConContCuent="showModal" :nroContrato="contrato" :vigencia="vigencia" :infoCuentPorCont="listCuentPorContr" @cierraModal="closeModal"></ModConsxContratxCuenta>
        <ModConsContrPorCuent :modConContPorCuent="showModContXCue" :nroCuenta="numCuenta" :infoCuentas="listContrPorCuent" @cierraModal="closeModal"></ModConsContrPorCuent>
    </div>
</template>
<script>

import ContratoSaldos from '../../services/ContratoSaldos';
import Tercero from '../../services/Tercero';
import Authentication from "../../services/Authentication"
import ModConsxContratxCuenta from './ModConsxContratxCuenta.vue';
import ModConsContrPorCuent from './ModConsContrPorCuent.vue';
import * as XLSX from "exceljs";

export default {
    name : 'ConsultaSaldosContables',
    components : { 
        ModConsxContratxCuenta, 
        ModConsContrPorCuent
    },
    data : () => ({
        nameCompania : '',
        showPorContrato : false,
        showPorCuenta : false,
        fechaSaldos : '',
        lstFechaSaldos : [],
        lstSaldContab : [],
        lstSaldos : [],
        lstSaldPorCuenta : [],
        listTercero : [],
        perPage: 500,
        currentPage: 1,
        filtroContrato: '',
        fields: [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'tipo_activo', label: 'Tipo activo', sortable: false },
            { key: 'identificacion', label: 'Proveedor', sortable: false },
            // { key: 'centro_costo', label: 'Centro costo', sortable: false }
        ],
        showModal : false,
        contrato : '',
        vigencia : '',
        numCuenta : null,
        showModContXCue : false,
        listCuentPorContr : [],
        listContrPorCuent : [],
        btnGenExcel : false,
        loading: false,
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Consulta saldos',
                    subTitle : 'Consulta por contrato',
                    subTitleCuenta : 'Consulta por cuenta',
                    fechaSaldos : 'Fecha saldos:',
                    fecha : 'Fecha causación',
                    consultar : 'Consultar',
                    noRow : 'No hay registros',
                    consPorContrato : 'Consulta por contrato',
                    consPorCuenta : 'Consulta por cuenta',
                    seleccion : 'Seleccione...',
                }
            }else{
                return {
                    title : 'Check balances',
                    subTitle : 'Contract consultation',
                    subTitleCuenta : 'Inquiry by account',
                    fechaSaldos : 'Balance date:',
                    fecha : 'Balance date',
                    consultar : 'Consult',
                    noRow : 'There are no records',
                    consPorContrato : 'Contract consultation',
                    consPorCuenta : 'Inquiry by account',
                    seleccion : 'Select...',
                }
            }
        }
    },
    methods : {
        consultSaldosPorContrato(){
            if(this.fechaSaldos != ''){

                this.loading = true
                
                ContratoSaldos.getContratoSaldosByVig(this.fechaSaldos)
                .then((result) => {
                    // console.log(result.data.listaSaldos);
                    this.lstSaldos = result.data.listaSaldos
                    this.btnGenExcel = true
                    this.showPorContrato = true
                    this.showPorCuenta = false
                }).catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false
                });

            }else{
                this.$toast.error('Diligenciar la fecha.')
            }
        },
        consultSaldosPorCuenta(){

            if(this.fechaSaldos != ''){
                
                this.loading = true

                ContratoSaldos.getCuentasSaldosByVig(this.fechaSaldos)
                .then((result) => {
                    this.lstSaldPorCuenta = result.data.listaSaldosPorCuenta
                    this.btnGenExcel = true
                    this.showPorCuenta = true
                    this.showPorContrato = false
                }).catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false
                });
            }else{
                this.$toast.error('Diligenciar la fecha.')
            }
        },
        proveedor(identify){
            if	(identify == null || identify == undefined) {
			return identify
            }
            let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify)

            if	(nameTercero == undefined) {
                return "Sin Nombre "+identify
            }
            return nameTercero.nombre
        },
        consSaldPorContrCuenta(contrato,vigencia){

            ContratoSaldos.getContratoSaldosByContrAndVigen(contrato,vigencia)
            .then((result) => {
                // console.log(result.data.listaSaldosxContyVig);
                this.listCuentPorContr = result.data.listaSaldosxContyVig
                this.showPorContrato = true
                this.showPorCuenta = false

            }).catch((err) => {
                console.log(err);
            });

            this.contrato = contrato
            this.vigencia = vigencia
            this.showModal = true
        },
        consSaldCuenta(cuenta){
            // console.log('cuenta :',cuenta);
            
            ContratoSaldos.getContratosSaldosByVigCuent(this.fechaSaldos,cuenta)
            .then((result) => {
                // console.log(result.data);
                this.listContrPorCuent = result.data.listaSaldDeContPorCuenta
                this.numCuenta = cuenta
                this.showModContXCue = true
            }).catch((err) => {
                console.log(err);
            });
            
        },
        closeModal(val){
            this.showModal = val
            this.showModContXCue = val
        },
        async consSaldContByVig(){

            try {
                const res = await ContratoSaldos.consulSaldContByVigencia(this.fechaSaldos)
                this.lstSaldContab = res.data.listSaldContab
                
            } catch (error) {
                console.log(error);
            }
        },
        async genExcelSaldContabPorCont(){

            await this.consSaldContByVig()

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Saldos por contrato "+this.fechaSaldos)

            const titulo = ["Saldos por contrato "+this.fechaSaldos]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:G1')
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 11};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            // =======================
            // FILA 2
            // =======================
            worksheet.addRow(['']);
            worksheet.mergeCells('A2:G2');

            const cell2 = worksheet.getCell('A2');

            cell2.value = {
                richText: [
                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` },

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` },

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` },
                ]
            };

            cell2.font = { name: 'Arial', size: 12 };
            cell2.alignment = { horizontal: 'center', vertical: 'middle' };

            worksheet.addRow(['']);
            worksheet.mergeCells('A3:G3')

            const tituloCelda = [
                'Contrato',
                'Cuenta',
                'Nombre',
                'Proveedor',
                'Tipo activo',
                'Centro costo',
                'Saldo'
            ]

            const headerRow = worksheet.addRow(tituloCelda)
            headerRow.alignment = { horizontal: 'center' }

            headerRow.font = {
                name: 'Arial',
                size: 11,
                bold: true
            }

            headerRow.alignment = { horizontal: 'center' }

            this.lstSaldContab.map((e) => {
                worksheet.addRow([
                    e.nro_contrato,
                    e.cuenta,
                    e.nombre,
                    this.proveedor(e.identificacion),
                    e.tipo_activo,
                    e.centro_costo,
                    e.saldo
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){
                if ([1, 2, 3].includes(row)) continue; // 👈 omitir filas
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Saldos por contrato "+this.fechaSaldos+".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
            
            /*const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Saldos por contrato "+this.fechaSaldos)

            const titulo = ["Saldos por contrato - "+this.fechaSaldos]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:C1')
            worksheet.getCell('A1').font = { bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            const tituloCelda = [
                'Contrato',
                'Tipo activo',
                'Proveedor'
            ]

            worksheet.addRow(tituloCelda)
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = {
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.lstSaldos.map((e) => {
                worksheet.addRow([
                    e.nro_contrato,
                    e.tipo_activo,
                    this.proveedor(e.identificacion)
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Saldos por contrato "+this.fechaSaldos+".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();*/

        },
        async genExcelSaldContabPorCuent(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Saldos por cuenta "+this.fechaSaldos)

            const titulo = ["Saldos por cuenta - "+this.fechaSaldos]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:B1')
            worksheet.getCell('A1').font = { bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            const tituloCelda = [
                'Cuenta',
                'Nombre'
            ]

            worksheet.addRow(tituloCelda)
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = {
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.lstSaldPorCuenta.map((e) => {
                worksheet.addRow([
                    e.cuenta,
                    e.nombre,
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Saldos por cuenta "+this.fechaSaldos+".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();

        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear()
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11
            const dia = String(fecha.getDate()).padStart(2, '0')

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){

        Tercero.getAllTercero()
        .then((res) => {
            this.listTercero = res.data.listTercero
        })
        .catch((err) => console.log(err))

        ContratoSaldos.getListadoFechas()
        .then((res) => {
            // console.log(res.data.lstFechaSaldo);
            this.lstFechaSaldos = res.data.lstFechaSaldo
        })
        .catch((err) => console.log(err))

        Authentication.leaParametros()
        .then ((result) => {
            this.nameCompania = result.data.parametros.compania
        })
        .catch((err) => console.log(err))
    },
    watch:{
        fechaSaldos(val){
            if(val == ""){
                this.lstSaldos = []
                // this.btnGenExcel = false
            }
        }
    }
}
</script>

<style>

</style>